/* eslint-disable import/prefer-default-export */
export const generateDownloadDocument = (fileName, source, type, encoding = '') => {
  const downloadLink = document.createElement('a');
  if (encoding) downloadLink.href = `data:${type};${encoding},${source}`;
  else downloadLink.href = `data:${type};${source}`;
  downloadLink.download = fileName;
  downloadLink.click();
};
